import type { ReactNode } from 'react';

export type FigurinhaItem = {
    fig_codigo: string;
    fig_nome: string;
    fig_imagem: string;
};

export function buildFigurinhaMap(items: FigurinhaItem[]): Map<string, FigurinhaItem> {
    const m = new Map<string, FigurinhaItem>();
    for (const it of items) {
        m.set(it.fig_codigo.trim().toLowerCase(), it);
    }
    return m;
}

/** Texto com tokens `:codigo:` → imagens (catálogo do back). */
export function renderCommentWithFigurinhas(text: string, map: Map<string, FigurinhaItem>): ReactNode {
    const s = String(text);
    /** Igual ao back: `:[a-z0-9_]{2,64}:` — regex nova por chamada (evita `lastIndex` partilhado). */
    const re = /:([a-z0-9_]{2,64}):/gi;
    const onlyStickers = s.trim().length > 0 && s.replace(re, '').trim().length === 0;
    const nodes: ReactNode[] = [];
    let last = 0;
    let m: RegExpExecArray | null;
    while ((m = re.exec(s)) !== null) {
        if (m.index > last) nodes.push(<span key={`t-${last}`}>{s.slice(last, m.index)}</span>);
        const code = m[1].toLowerCase();
        const fig = map.get(code);
        if (fig) {
            nodes.push(
                <img
                    key={`img-${m.index}-${code}`}
                    src={fig.fig_imagem}
                    alt={fig.fig_nome}
                    title={fig.fig_nome}
                    className={`inline-block align-text-bottom object-contain mx-0.5 rounded-sm ${
                        onlyStickers ? 'h-16 w-16 max-h-[4rem]' : 'h-7 w-7 max-h-[1.75rem]'
                    }`}
                    loading="lazy"
                />,
            );
        } else {
            nodes.push(<span key={`miss-${m.index}`}>{m[0]}</span>);
        }
        last = m.index + m[0].length;
    }
    if (last < s.length) nodes.push(<span key="end">{s.slice(last)}</span>);
    return nodes.length > 0 ? nodes : s;
}
